import { type FilterRecord, FilterType } from "@/contexts/filters-sort-context";

import type { ActivityTabSelection } from "../activity/constants";
import {
  ActivityTabTypes,
  ActivityTabWhaleValuesType,
} from "../activity/constants";
import { FilterName } from "../top-traders/constants";

export type Filters = {
  [key: string]: {
    in?: string[];
    greaterThan?: number;
    lessThan?: number;
    after?: Date;
    before?: Date;
    equalTo?: string | boolean;
    notEqualTo?: string | boolean;
  };
};

export const formatFilters = (data: FilterRecord[]) => {
  const filter: Filters = {} as Filters;

  data.forEach((item) => {
    switch (item.type) {
      case FilterType.multiUserSelect:
        if (!item.value.length) {
          break;
        }
        filter[item.name] = {
          in: item.value.map((user) => user.publicKey || ""),
        };
        break;
      case FilterType.numeric:
        filter[item.name] = {
          ...(item.value.min && { greaterThan: Number(item.value.min) }),
          ...(item.value.max && { lessThanOrEqualTo: Number(item.value.max) }),
        };
        break;
      case FilterType.select:
        if (item.name === FilterName.TimeWindow) {
          filter[item.name] = {
            equalTo: item.value,
          };
        }
        break;
      case FilterType.date:
        filter[item.name] = {
          ...(item.value.after && { after: item.value.after }),
          ...(item.value.before && { before: item.value.before }),
        };
        break;
      default:
        break;
    }
  });

  return filter;
};

export const formatActivityTabFilters = (
  tab: ActivityTabSelection,
): {
  min: number;
  max?: number;
} => {
  const type = tab.type;

  switch (type) {
    case ActivityTabTypes.Shrimp:
      return {
        min: ActivityTabWhaleValuesType.Shrimp,
        max: ActivityTabWhaleValuesType.Fish,
      };
    case ActivityTabTypes.Fish:
      return {
        min: ActivityTabWhaleValuesType.Fish,
        max: ActivityTabWhaleValuesType.Dolphin,
      };
    case ActivityTabTypes.Dolphin:
      return {
        min: ActivityTabWhaleValuesType.Dolphin,
        max: ActivityTabWhaleValuesType.Whale,
      };
    case ActivityTabTypes.Whale:
      return {
        min: ActivityTabWhaleValuesType.Whale,
      };
    default:
      return {
        min: ActivityTabWhaleValuesType[
          type as keyof typeof ActivityTabWhaleValuesType
        ],
      };
  }
};
